<app-people-and-co-hero></app-people-and-co-hero>
<app-become-adonor></app-become-adonor>
<app-simple-ways></app-simple-ways>
<app-category-news></app-category-news>
<app-common-questions></app-common-questions>
<!-- <app-leader></app-leader> -->
<app-depositions></app-depositions>
<app-common-questions></app-common-questions>
<app-donors></app-donors>